import Device from '../utils/device';
import Cookie from '../utils/cookie';
import Trigger from '../event/trigger';

class MapScrubComponent {
    static get EVENT () {
        return {
            MAP_SCRUB_COMPLETE: 'map-scrub-component-complete',
        }
    }

    constructor(el, index) {
        this.render(el, index);
        return this;
    }

    hide () {
        TweenMax.set( this.line, { opacity: 0 } );
        TweenMax.set( this.dash, { opacity: 0 } );
        TweenMax.set( this.icon, { opacity: 0 } );

        TweenMax.to( this.button, 0.6, { scale: 0, ease: Cubic.easeInOut, delay: 0.3 } );
    }

    show () {
        this.enable();

        TweenMax.to( this.button, 0.6, { scale: 1, ease: Cubic.easeOut, delay: 0.8 } );
        TweenMax.to( this.line, 0.6, { opacity: 1, ease: Cubic.easeOut, delay: 1.0 } );
        TweenMax.to( this.dash, 0.6, { opacity: 1, ease: Cubic.easeOut, delay: 1.0 } );
        TweenMax.to( this.icon, 0.6, { opacity: 1, ease: Cubic.easeOut, delay: 1.0 } );
        TweenMax.to( this.text, 0.6, { opacity: 1, ease: Cubic.easeOut, delay: 1.0 } );
    }

    enable () {
        this.dinamicScrubPosition.x = 0;
        this.lockScrubPosition.x = this.dinamicScrubPosition.x;

        TweenMax.set( this.button, { x: this.dinamicScrubPosition.x } );
        TweenMax.set( this.line, { x: this.dinamicScrubPosition.x } );
        TweenMax.set( this.dash, { x: -(this.dinamicScrubPosition.x) } );

        $(this.button).on('mousedown touchstart', this.button_MOUSE_DOWN.bind(this));
    }

    disable () {
        $(window).off('mousemove touchmove');
        $(window).off('mouseup touchend');
        $(this.button).off('mousedown touchstart');

        $(this).trigger( MapScrubComponent.EVENT.MAP_SCRUB_COMPLETE );
    }

    window_MOVE ( e ) {
        e.preventDefault();

        var currentMousePosition = { x: ( e.originalEvent.touches ) ? e.originalEvent.touches[0].pageX : e.pageX, y: ( e.originalEvent.touches ) ? e.originalEvent.touches[0].pageY : e.pageY };
        var currentScrubPosition = { x: currentMousePosition.x - this.initialMousePosition.x, y: currentMousePosition.y - this.initialMousePosition.y };
        this.dinamicScrubPosition.x = this.lockScrubPosition.x + currentScrubPosition.x;

        this.dinamicScrubPosition.x = ( this.dinamicScrubPosition.x < 0 ) ? 0 : this.dinamicScrubPosition.x;
        this.dinamicScrubPosition.x = ( this.dinamicScrubPosition.x > this.maxScrubWidth ) ? this.maxScrubWidth : this.dinamicScrubPosition.x;

        var percent = (this.dinamicScrubPosition.x ) / this.maxScrubWidth;

        TweenMax.to( this.button, 0.3, { x: this.dinamicScrubPosition.x } );
        TweenMax.to( this.line, 0.3, { x: this.dinamicScrubPosition.x } );
        TweenMax.to( this.dash, 0.3, { x: -(this.dinamicScrubPosition.x) } );

        if(percent >= 1) {
            this.disable();
        }
    }

    window_MOUSE_UP ( e ) {
        e.preventDefault();

        this.dinamicScrubPosition.x = 0;
        this.lockScrubPosition.x = this.dinamicScrubPosition.x;

        TweenMax.to( this.button, 0.6, { x: this.dinamicScrubPosition.x, ease: Cubic.easeInOut } );
        TweenMax.to( this.line, 0.6, { x: this.dinamicScrubPosition.x, ease: Cubic.easeInOut } );
        TweenMax.to( this.dash, 0.6, { x: -(this.dinamicScrubPosition.x), ease: Cubic.easeInOut } );

        TweenMax.killTweensOf( this.text );
        TweenMax.to( this.text, 0.3, { opacity: 1, ease: Cubic.easeOut, delay: 0.6 } );

        $(window).off('mousemove touchmove');
        $(window).off('mouseup touchend');
    }

    button_MOUSE_DOWN ( e ) {
        e.preventDefault();

        this.initialMousePosition = { x: ( e.originalEvent.touches ) ? e.originalEvent.touches[0].pageX : e.pageX, y: ( e.originalEvent.touches ) ? e.originalEvent.touches[0].pageY : e.pageY };
        this.maxScrubWidth = this.slider.width();

        TweenMax.killTweensOf( this.text );
        TweenMax.to( this.text, 0.3, { opacity: 0, ease: Cubic.easeOut } );

        $(window).on('mousemove touchmove', this.window_MOVE.bind(this));
        $(window).on('mouseup touchend', this.window_MOUSE_UP.bind(this));
    }

    render (el, index) {
        this.element = $(el);
        this.button = this.element.find('*[data-component="c-map-scrub-component-button"]');
        this.icon = this.element.find('*[data-component="c-map-scrub-component-icon"]');
        this.slider = this.element.find('*[data-component="c-map-scrub-component-slider"]');
        this.line = this.element.find('*[data-component="c-map-scrub-component-line"]');
        this.dash = this.element.find('*[data-component="c-map-scrub-component-dash"]');
        this.text = this.element.find('*[data-component="c-map-scrub-component-text"]');        

        this.maxScrubWidth = 0;
        this.lockScrubPosition = { x: 0, y: 0 };
        this.dinamicScrubPosition = { x: 0, y: 0 };
        this.initialMousePosition = { x: 0, y: 0 };

        $(this.button).on('mousedown touchstart', this.button_MOUSE_DOWN.bind(this));
    }
}

export default MapScrubComponent;